import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [impersonating, setImpersonating] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser({ ...data, impersonating: undefined });
      setImpersonating(data.impersonating || null);
    } catch (_e) {
      setUser(null);
      setImpersonating(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const startImpersonate = async (userId) => {
    try {
      await api.post("/admin/impersonate/start", { target_user_id: userId });
    } catch (_e) { /* still allow */ }
    localStorage.setItem("impersonate_user_id", userId);
    await checkAuth();
    window.location.href = "/dashboard";
  };

  const stopImpersonate = async () => {
    const prev = localStorage.getItem("impersonate_user_id");
    localStorage.removeItem("impersonate_user_id");
    if (prev) {
      try { await api.post("/admin/impersonate/stop", { target_user_id: prev }); } catch (_e) {}
    }
    await checkAuth();
    window.location.href = "/admin";
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) {}
    localStorage.removeItem("session_token");
    localStorage.removeItem("impersonate_user_id");
    setUser(null);
    setImpersonating(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, impersonating, loading, checkAuth, logout, startImpersonate, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
